import { useFunction } from "@aec-craft/nb-generative";
import { useTranslate } from "@fe/i18n/use-translate";
import { CircleAlertIcon, CircleCheckIcon, XIcon } from "lucide-react";
import { memo, useEffect } from "react";
import { type SnackbarType, useSnackbarStore } from "./snackbar.store";

const durationMs = 6000;

export const SnackbarItem = memo<{
	id: string;
	message: string;
	type: SnackbarType;
}>(({ id, message, type }) => {
	const t = useTranslate();
	const onClose = useFunction(() => {
		useSnackbarStore.getState().removeMessage(id);
	});

	useEffect(() => {
		const timeout = setTimeout(onClose, durationMs);
		return () => clearTimeout(timeout);
	}, [onClose]);

	const role = type === "error" ? "alert" : "status";

	return (
		<div
			role={role}
			className="pointer-events-auto flex items-center gap-2 rounded-xl bg-background py-2 pr-2 pl-3 text-sm shadow-lg ring-1 ring-border animate-in fade-in slide-in-from-bottom-4"
		>
			{type === "success" && <CircleCheckIcon className="size-4 shrink-0" />}
			{type === "error" && (
				<CircleAlertIcon className="size-4 shrink-0 text-destructive" />
			)}
			<span>{message}</span>
			<button
				type="button"
				aria-label={t.statusMessages.dismiss}
				onClick={onClose}
				className="rounded-sm p-1 text-muted-foreground hover:text-foreground"
			>
				<XIcon className="size-4" />
			</button>
		</div>
	);
});
SnackbarItem.displayName = "SnackbarItem";
